import { Link } from "react-router-dom";

const DisabledLink = ({ to, disabled, children, className = "", ...props }) => {
  return disabled ? (
    <span className={`d-inline-block ${className} opacity-50`} {...props}>
      {children}
    </span>
  ) : (
    <Link to={to} className={className} {...props}>
      {children}
    </Link>
  );
};

export default DisabledLink;
